export const TOOLBAR_BUTTON =
    "rounded border border-primary/40 bg-mgs-surface px-2 py-0.5 text-xs text-laranjinha/80 hover:border-primary hover:text-laranjinha disabled:opacity-50";
export const ICON_BUTTON = "rounded px-1 text-laranjinha/70 hover:text-laranjinha disabled:opacity-30";
